import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { Taxonomy } from '../definitions/taxonomy.enum';
import { TaxonomyService } from '../services/taxonomy.service';

@Pipe({
  name: 'simxTaxonomyTermLabel',
  standalone: false,
})
export class TaxonomyTermLabelPipe implements PipeTransform {
  private readonly _taxonomyService = inject(TaxonomyService);

  transform(term: string, taxonomy: Taxonomy): Observable<string> {
    return new Observable(observer => {
      this._taxonomyService.getTaxonomy(taxonomy).subscribe({
        next: taxonomyTerms => {
          observer.next(
            taxonomyTerms.find(
              taxonomyTerm =>
                taxonomyTerm.taxonomy === taxonomy &&
                taxonomyTerm.term === term,
            )?.label ?? term,
          );
          observer.complete();
        },
        error: () => {
          observer.next(term);
          observer.complete();
        },
      });
    });
  }
}
